// extracted by mini-css-extract-plugin
export default {"root":"SYeDo0","isDisabled":"Uv5baA"};